import React from 'react';

const ClosedEyeIcon = ({
  width = 20,
  height = 21,
  fillColor = "#A3AED0",
  lineStrokeColor = "#A3AED0",
  lineStrokeWidth = 2,
  className = ""
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_closed_eye)">
        <path
          d="M10.0026 5.91667C13.1609 5.91667 15.9776 7.69167 17.3526 10.5C15.9776 13.3083 13.1693 15.0833 10.0026 15.0833C6.83594 15.0833 4.0276 13.3083 2.6526 10.5C4.0276 7.69167 6.84427 5.91667 10.0026 5.91667ZM10.0026 4.25C5.83594 4.25 2.2776 6.84167 0.835938 10.5C2.2776 14.1583 5.83594 16.75 10.0026 16.75C14.1693 16.75 17.7276 14.1583 19.1693 10.5C17.7276 6.84167 14.1693 4.25 10.0026 4.25ZM10.0026 8.41667C11.1526 8.41667 12.0859 9.35 12.0859 10.5C12.0859 11.65 11.1526 12.5833 10.0026 12.5833C8.8526 12.5833 7.91927 11.65 7.91927 10.5C7.91927 9.35 8.8526 8.41667 10.0026 8.41667ZM10.0026 6.75C7.93594 6.75 6.2526 8.43333 6.2526 10.5C6.2526 12.5667 7.93594 14.25 10.0026 14.25C12.0693 14.25 13.7526 12.5667 13.7526 10.5C13.7526 8.43333 12.0693 6.75 10.0026 6.75Z"
          fill={fillColor}
        />
        <line
          x1="3"
          y1="18"
          x2="17"
          y2="4"
          stroke={lineStrokeColor}
          strokeWidth={lineStrokeWidth}
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_closed_eye">
          <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ClosedEyeIcon;